import { useCallback } from 'react';
import useSWR, { SWRResponse, Key, useSWRConfig } from 'swr';
import { AxiosError } from 'axios';

import { Response$getReservationFlowMe$Status$200 } from 'src/openapi/generated/apiClient';
import { isAxiosError, useClientSideApiClient } from 'src/openapi/axiosClient';

export type UseGetReservationFlowMeValue = SWRResponse<
  Response$getReservationFlowMe$Status$200['application/json'] | undefined,
  AxiosError
>;

export const getGetReservationFlowMeKey: () => Key = () => {
  return {
    path: '/api/reservation_flow/me',
  };
};

export const useGetReservationFlowMe: () => UseGetReservationFlowMeValue =
  () => {
    const client = useClientSideApiClient();
    const key = getGetReservationFlowMeKey();

    const fetcher: () => Promise<
      Response$getReservationFlowMe$Status$200['application/json'] | undefined
    > = async () => {
      try {
        const result = await client.getReservationFlowMe();

        return result;
      } catch (error) {
        // 未ログイン時はエラーを発生させずundefinedを返す
        if (
          isAxiosError(error) &&
          typeof error.response !== 'undefined' &&
          error.response.status === 401
        ) {
          return undefined;
        }

        throw error;
      }
    };

    // 未ログイン時などに401エラーが発生する可能性があるため、shouldRetryOnErrorをfalseに設定する
    return useSWR(key, fetcher, { shouldRetryOnError: false });
  };

export interface UseRevalidateGetReservationFlowMeValue {
  revalidateGetReservationFlowMe: () => Promise<void>;
}

export const useRevalidateGetReservationFlowMe: () => UseRevalidateGetReservationFlowMeValue =
  () => {
    const { mutate } = useSWRConfig();

    const revalidateGetReservationFlowMe = useCallback(async () => {
      await mutate(getGetReservationFlowMeKey());
    }, [mutate]);

    return { revalidateGetReservationFlowMe };
  };
